module.exports = __webpack_public_path__ + "static/media/StopGo.413dec44.pdf";